import { call, put, takeEvery } from 'redux-saga/effects';

import { utils as commonUtils } from '@febos-io/common';

import * as types from './types';

import {
  setClinics,
  setExams,
  setLastClinic,
  setLoadingClinics,
  setLoadingExams,
  setLoadingUsers,
  setUsers
} from './actions';
import { getCompanyClinicList, getCompanyUserList, getExamList } from '../config';
import {
  handleCleanOldAppointments,
  handleReserveAppointment,
  handleSearchAppointments,
  handleSearchMyAppointments,
  handleSearchSchedulerStates,
  handleSearchSheduler
} from './sagas_ts';

function* handleLoadCompanyClinics({ payload: { companyId, }, }) {
  try {
    yield put(setLoadingClinics(true));
    const request = new commonUtils.Request();
    const {
      clinics = [],
    } = yield call(() =>(
      request.exec(getCompanyClinicList(companyId, 1, 10000))
    ));
    yield put(
      setClinics({
        companyId,
        clinics: clinics.reduce((acc, clinic) => {
          return {
            ...acc,
            [clinic.clinicId]: clinic,
          };
        }, {}),
      })
    );
  } catch (error) {
    console.error('🚨 Error en handleLoadCompanyClinics:', {
      error: error.message || error,
      companyId,
      timestamp: new Date().toISOString(),
    });
  } finally {
    yield put(setLoadingClinics(false));
  }
}

function* handleLoadCompanyExams({
  payload: {
    // eslint-disable-next-line no-unused-vars
    companyId, // A futuro quisas no todas las empresas usen todos los examenes
  },
}) {
  try {
    yield put(setLoadingExams(true));
    const request = new commonUtils.Request();
    const { exams, } = yield call(() => request.exec(getExamList(1, 10000)));
    yield put(
      setExams({
        companyId,
        exams,
      })
    );
  } catch (error) {
    console.error('🚨 Error en handleLoadCompanyExams:', {
      error: error.message || error,
      companyId,
      timestamp: new Date().toISOString(),
    });
  } finally {
    yield put(setLoadingExams(false));
  }
}

function* handleLoadCompanyUsers({ payload: { companyId, filter, }, }) {
  try {
    yield put(setLoadingUsers(true));
    const request = new commonUtils.Request();
    const {
      users = [],
    } = yield call(() => (
      request.exec(getCompanyUserList(companyId, 1, 1000, filter))
    ));
    yield put(
      setUsers({
        companyId,
        filter,
        users,
      })
    );
  } catch (error) {
    console.error('🚨 Error en handleLoadCompanyUsers:', {
      error: error.message || error,
      companyId,
      filter,
      timestamp: new Date().toISOString(),
    });
  } finally {
    yield put(setLoadingUsers(false));
  }
}

function* handleSetLastClinic({ payload: { companyId, clinicId, }, }) {
  try {
    yield put(setLastClinic(companyId, clinicId));
  } catch (error) {
    console.error('🚨 Error en handleSetLastClinic:', {
      error: error.message || error,
      companyId,
      clinicId,
      timestamp: new Date().toISOString(),
    });
  }
}

export const sagas = [
  takeEvery(types.HANDLE_LOAD_COMPANY_CLINICS, handleLoadCompanyClinics),
  takeEvery(types.HANDLE_LOAD_EXAMS, handleLoadCompanyExams),
  takeEvery(types.HANDLE_LOAD_COMPANY_USERS, handleLoadCompanyUsers),
  takeEvery(types.HANDLE_LOAD_LAST_CLINIC, handleSetLastClinic),
  takeEvery(types.HANDLE_SEARCH_SCHEDULER, handleSearchSheduler),
  takeEvery(types.HANDLE_SEARCH_MY_SCHEDULER, handleSearchMyAppointments),
  takeEvery(types.HANDLE_SEARCH_APPOINTMENTS, handleSearchAppointments),
  takeEvery(types.HANDLE_RESERVE_APPOINTMENTS, handleReserveAppointment),
  takeEvery(types.HANDLE_SEARCH_SCHEDULER_STATES, handleSearchSchedulerStates),
  takeEvery(types.HANDLE_CLEAN_OLD_APPOINTMENTS, handleCleanOldAppointments),
];

export default sagas;
